module.exports = __webpack_public_path__ + "img/logo.e6d9f9b2.png";